import { PersonSearchResultTeaseProps } from "design-system/components/primitives/person-search-result-tease/person-search-result-tease";
import { ModernSearchHit, SearchDisplay } from "frontend/types";
import { isSearchHitType } from "./is-search-hit-type";

export function createModernSearchResultPersonTease(
  data?: ModernSearchHit,
): PersonSearchResultTeaseProps | undefined {
  if (data && typeof data === "object") {
    const props: PersonSearchResultTeaseProps = {
      type: "PersonSearchResult",
      link: data.url,
    };

    if (data.title) {
      props.name = data.title;
    }

    if (data.description) {
      props.title = [data.description];
    }

    if (isSearchHitType<SearchDisplay>("modern", data)) {
      if (data.display?.thumbnail?.src) {
        props.portrait = {
          src: data.display?.thumbnail.src,
          gravity: data.display.thumbnail.gravity,
          alt: data.display.thumbnail.alt,
          aspectRatio: data.display.thumbnail.aspectRatio,
        };
      }
      if (data.location) {
        props.location = data.location;
      }
      if (data.display?.degreeClassYear?.length === 1) {
        props.degree = data.display.degreeClassYear.toString();
      }
      if (data.display?.bio?.toLowerCase() === "deceased") {
        props.deceased = true;
      }
      if (data.url) {
        props.link = data.url;
      }
      // Added for QA testing before Alumni site goes live, can be removed later
      if (
        props.link &&
        props.link
          .toLowerCase()
          .indexOf("/community/pages/view-profile.aspx?alumid=") > -1
      ) {
        const alumId = props.link.toLowerCase().split("alumid=")[1];
        props.link = `/directory/view-profile?alumId=${alumId}`;
      }
    }

    return props;
  }
}
